import React, {FunctionComponent, useCallback, useState} from 'react';
import './InvoiceItemsTableItemRow.scss';
import {Item, ItemSectionSettings} from "../../models/item.model";
import {FilePreviewModal} from "../FilePreviewModal/FilePreviewModal";
import {File} from "../../models/file.model";
import {InvoiceItemRowFilePreview} from "./InvoiceItemRowFilePreview/InvoiceItemRowFilePreview";

export interface InvoiceItemsTableItemRowProps {
    itemSection: ItemSectionSettings;
    item: Item;
}

export const InvoiceItemsTableItemRow: FunctionComponent<InvoiceItemsTableItemRowProps> = (props) => {
    const {item, itemSection} = props;
    const [currentFilePreviewIndex, setCurrentFilePreviewIndex] = useState<number | null>(null);

    const closeModal = useCallback(() => {
        setCurrentFilePreviewIndex(null);
    }, [setCurrentFilePreviewIndex]);

    const onViewImage = useCallback((image: File) => {
        setCurrentFilePreviewIndex(item.files.indexOf(image));
    }, [setCurrentFilePreviewIndex]);

    return item ? (
        <div className="invoice-item">
            {
                itemSection.is_item_title_visible
                    ? <div className='invoice-item-title'>
                        {item.title}
                    </div> : <div className='invoice-item-title'>-</div>
            }

            {
                item.is_price_visible
                    ? <div className='invoice-item-price'>
                        {item.unit_price}
                    </div>
                    : (itemSection.is_price_visible && <div className='invoice-item-price'/>)
            }

            {
                item.is_unit_tax_amount_visible
                    ? <div className='invoice-item-unit-tax'>
                        {item.unit_tax_amount}
                    </div>
                    : (itemSection.is_unit_tax_amount_visible && <div className='invoice-item-unit-tax'/>)
            }

            {
                item.is_quantity_visible
                    ? <div className='invoice-item-quantity'>
                        {item.quantity}
                        <div className='invoice-item-unit-measure'>{item.unit_measure_display_text}</div>
                    </div>
                    : (itemSection.is_quantity_visible && <div className='invoice-item-quantity'/>)
            }

            {
                item.is_taxed_visible
                    ? <div className='invoice-item-tax'>
                        {item.tax_value}
                    </div>
                    : (itemSection.is_taxed_visible && <div className='invoice-item-tax'/>)
            }

            {
                item.is_total_without_tax_visible
                    ? <div className='invoice-item-amount-without-tax'>
                        {item.total_without_tax}
                    </div>
                    : (itemSection.is_total_without_tax_visible && <div className='invoice-item-amount-with-tax'/>)
            }

            {
                item.is_total_visible
                    ? <div className='invoice-item-total'>
                        {item.total}
                    </div>
                    : (itemSection.is_total_visible && <div className='invoice-item-total'/>)
            }

            {
                item.is_total_with_tax_visible
                    ? <div className='invoice-item-amount-with-tax'>
                        {item.total_with_tax}
                    </div>
                    : (itemSection.is_total_with_tax_visible && <div className='invoice-item-amount-with-tax'/>)
            }

            {
                item.is_description_visible && item.description
                    ? <div className="invoice-item-description">
                        {item.description}
                    </div>
                    : null
            }
            {item.files?.length && <div className="invoice-item-files">
                {item.files.map((file) => {
                    return <InvoiceItemRowFilePreview file={file} onViewImage={onViewImage}/>
                })}
            </div>}

            {currentFilePreviewIndex !== null && <FilePreviewModal files={item.files}
                                                                   currentFileIndex={currentFilePreviewIndex}
                                                                   onCloseModal={closeModal}/>}
        </div>
    ) : null;
};
